import { Expose } from 'class-transformer';

export class ValuePairDto<T> {
  @Expose() current!: T;
  @Expose() previous!: T;
}
